export const USER_MENU_DATA = [
  { id: 1, label: 'Profile', href: '/user/profile' },
  { id: 2, label: 'Messages', href: '/community/messages' },
  { id: 3, label: 'FAQ', href: '/faq' },
  { id: 4, label: 'Contact', href: '/contact-us' },
];
